/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Not_CsvInputs */



/**
* | output |
* | --- |
* | "Choose a .csv file." |
*
* @param {Team_Manager_Import_Not_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_not_csv = /** @type {((inputs?: Team_Manager_Import_Not_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Not_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un fichier .csv.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine .csv-Datei.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli un file .csv.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл .csv.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige un archivo .csv.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择 .csv 文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ (".csv ファイルを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ (".csv फ़ाइल चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha um ficheiro .csv.")
	return /** @type {LocalizedString} */ ("Choose a .csv file.")
});